import axios from 'axios';

export default axios.create({
  // baseURL: 'http://localhost:8080',
  // baseURL: 'https://dev.atto-chempanda.com', // IT環境
  // baseURL: 'https://punchout.atto-chempanda.com/', // コピー環境
  baseURL: 'https://atto-chempanda.com', // 本番環境


  headers: {
    'content-type': 'multipart/form-data',
    'X-Requested-With': 'XMLHttpRequest',
  },
});
